import data from "../../../../../packages/react/src/drafts/TabPanels/TabPanels.docs.json";
import * as React from 'react';
export default {
  data,
  React
};